import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { UserRecord } from '../entities/records';
import * as selectors from '../entities/User/selectors';

function mapStateToProps(state, { userId, currentUserId }) {
  return {
    user: selectors.userById(state, userId || currentUserId),
  };
}

export default compose(
  setPropTypes({
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    user: PropTypes.instanceOf(UserRecord),
  }),
)(mapStateToProps);
